import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-regionalhome',
  templateUrl: './regionalhome.component.html',
  styleUrls: ['./regionalhome.component.css']
})
export class RegionalhomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
